module.exports = __webpack_public_path__ + "images/5db1fe5ca96b12dbe519fb48acf292367.svg";